/**
 * Asynchronously loads the component for HomePage
 */

import React from 'react';
import loadable from 'utils/loadable';
import LoadingIndicator from 'components/LoadingIndicator';
import ClipLoader from "react-spinners/ClipLoader";
import RingLoader from "react-spinners/RingLoader";
export default loadable(() => import('./index'), {
  fallback: <div className="sweet-loading">
  <ClipLoader
    size={100}
    color={"#123abc"}
    loading={true}
  />
</div>
});
